// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1GKnh","error":"Textarea_error__13UxA","readonly":"Textarea_readonly__1VlWP","disabled":"Textarea_disabled__1PNFM"};